/**
 * CDN Asset URLs
 *
 * Static brand assets (logos) are served from the Parrot CDN as SVG, so they
 * stay crisp at any size — unlike the low-res placeholder PNGs the app used
 * before. Mirrors the location-intelligence `lib/cdn.ts` pattern.
 *
 * Base URL is configured via VITE_CDN_BASE_URL. The logos are the generic
 * Parrot wordmark/logomark (no product-specific text), so the shared
 * location-intelligence namespace is a safe default until streaming-economics
 * gets its own.
 */

/** CDN base URL — falls back to the shared Parrot asset namespace. */
export const CDN_BASE =
  import.meta.env.VITE_CDN_BASE_URL ||
  'https://cdn-fastly.parrotanalytics.com/images/location-intelligence';

/**
 * Four logo variants: full wordmark / logomark × dark-bg / light-bg.
 * The sidebar shows exactly one based on its collapse state and the app theme.
 */
export const LOGO = {
  fullDarkBg: `${CDN_BASE}/logos/full-dark-bg.svg`,
  fullLightBg: `${CDN_BASE}/logos/full-light-bg.svg`,
  logomarkDarkBg: `${CDN_BASE}/logos/logomark-dark-bg.svg`,
  logomarkLightBg: `${CDN_BASE}/logos/logomark-light-bg.svg`,
} as const;
